
/* ===== Idle warning modal (orange dashed box) — only when logged in ===== */
(function npIdleWarning(){
  const TOTAL_IDLE_MS = 600 * 1000;   // total idle time before logout
  const WARNING_MS    = 30 * 1000;   // warning countdown

  let idleTimer=null, forceTimer=null, tickInt=null, remain=0;

  const app = document.getElementById('np-loyalty-app') || document.body;
  const isLoggedIn = () => {
    // const d = document.getElementById('dashboard');
    return true;
  };

  // ---------- Build UI (inline styles; no theme impact) ----------
  let warnWrap, countEl, btnCont, btnOut, endedWrap, btnOk;

  function ensureUINodes(){
    if (warnWrap) return;

    // Backdrop for warning
    warnWrap = document.createElement('div');
    Object.assign(warnWrap.style, {
      position:'fixed', inset:'0', display:'none', alignItems:'center', justifyContent:'center',
      background:'rgba(0,0,0,.35)', zIndex:'9999'
    });

    // Orange dashed box (warning)
    const box = document.createElement('div');
    Object.assign(box.style, {
      background:'#fff7ed',                
      border:'2px dashed #f59e0b',         
      color:'#7c2d12',                     
      borderRadius:'14px',
      padding:'18px',
      width:'min(820px,94vw)',
      textAlign:'center',
      fontFamily:'inherit'
    });

    const h = document.createElement('div');
    h.textContent='Still Here?';
    Object.assign(h.style,{fontWeight:'800', margin:'0 0 8px', fontSize:'18px'});

    const p = document.createElement('div');
    const cnt = document.createElement('span');
    cnt.style.fontWeight='800'; cnt.style.color='#b45309';
    p.append('For your security, your session will end in ', cnt, ' seconds due to inactivity.');
    Object.assign(p.style,{margin:'0 0 12px'});
    countEl = cnt;

    const actions = document.createElement('div');
    Object.assign(actions.style,{display:'flex', gap:'10px', marginTop:'6px'});


    btnCont = document.createElement('button');
    btnCont.type='button'; btnCont.textContent='Yes, I’m still here';
    Object.assign(btnCont.style,{
      flex:'1', padding:'12px', borderRadius:'12px',
      border:'2px solid #192853', background:'#192853', color:'#fff', cursor:'pointer'
    });

    
    btnOut = document.createElement('button');
    btnOut.type='button'; btnOut.textContent='Log out';
    Object.assign(btnOut.style,{
      flex:'1', padding:'12px', borderRadius:'12px',
      border:'2px solid #192853', background:'#fff', color:'#192853', cursor:'pointer'
    });

    actions.append(btnCont, btnOut);
    box.append(h,p,actions);
    warnWrap.append(box);
    app.appendChild(warnWrap);

    
    endedWrap = document.createElement('div');
    Object.assign(endedWrap.style,{
      position:'fixed', inset:'0', display:'none', alignItems:'center', justifyContent:'center',
      background:'rgba(0,0,0,.35)', zIndex:'9999'
    });
    const endedBox = document.createElement('div');
    Object.assign(endedBox.style,{
      background:'#fff7ed', border:'2px dashed #f59e0b', color:'#7c2d12',
      borderRadius:'14px', padding:'18px', width:'min(560px,92vw)', textAlign:'center'
    });
    const eh=document.createElement('div'); eh.textContent='Session Ended'; Object.assign(eh.style,{fontWeight:'800', margin:'0 0 8px'});
    const ep=document.createElement('div'); ep.textContent='Your session has ended due to inactivity.'; Object.assign(ep.style,{margin:'0 0 12px'});
    btnOk=document.createElement('button'); btnOk.type='button'; btnOk.textContent='OK';
    Object.assign(btnOk.style,{padding:'12px 16px', borderRadius:'12px', border:'2px solid #192853', background:'#192853', color:'#fff', cursor:'pointer'});
    endedBox.append(eh,ep,btnOk); endedWrap.append(endedBox); app.appendChild(endedWrap);

    btnCont.addEventListener('click', continueSession);
    btnOut.addEventListener('click',  forceLogout);
    btnOk.addEventListener('click',   ()=> endedWrap.style.display='none');
  }

  // ---------- Logic ----------
  function clearTimers(){ clearTimeout(idleTimer); clearTimeout(forceTimer); clearInterval(tickInt); }
  function hideWarning(){ if (warnWrap) warnWrap.style.display='none'; clearInterval(tickInt); }

  function schedule(){
    clearTimers(); hideWarning();
    if (!isLoggedIn()) return;
    const warnAfter = Math.max(0, TOTAL_IDLE_MS - WARNING_MS);
    idleTimer = setTimeout(showWarning, warnAfter);
   
  }

  function reload_page(){
     location.reload();
  }

  function add_session(){
      sessionStorage.setItem("timout_logout", "true");
  }

  function showWarning(){
    console.log('show')
    if (!isLoggedIn()) return;
    ensureUINodes();
    remain = Math.ceil(WARNING_MS/1000);
    countEl.textContent = String(remain);
    warnWrap.style.display='flex';

    tickInt = setInterval(()=>{
      remain -= 1;
      if (remain < 0) remain = 0;
      countEl.textContent = String(remain);
    }, 1000);

    forceTimer = setTimeout(forceLogout, WARNING_MS);
    setTimeout(add_session, WARNING_MS);
  }

  function continueSession(){ schedule();reload_page(); }
  function forceLogout(){ try{document.querySelector('.logout-btn').click();}catch{} location.reload(); }

  const onActivity = () => { if (warnWrap && warnWrap.style.display==='flex') return; if (isLoggedIn()) schedule(); };
  ['mousemove','mousedown','keydown','touchstart','touchmove','scroll','wheel','click']
    .forEach(evt=>document.addEventListener(evt,onActivity,{passive:true}));

  const dash = document.getElementById('dashboard');
  if (dash){
    const obs = new MutationObserver(()=>{ isLoggedIn() ? schedule() : (clearTimers(), hideWarning()); });
    obs.observe(dash,{attributes:true, attributeFilter:['class']});
  }

  try{
    if (localStorage.getItem('np_idle_ended')==='1'){
      localStorage.removeItem('np_idle_ended');
      ensureUINodes(); endedWrap.style.display='flex';
    }
  }catch{}

  if (isLoggedIn()) schedule();
})();